import React, { Component } from 'react';
import { Col, FormGroup, Label, Input, ButtonGroup, Button, TabPane, TabContent} from 'reactstrap';
import classnames from 'classnames';
import './BenchmarkBuildingConsumption.css';
import _ from 'lodash';
import update from 'immutability-helper';

class BenchmarkBuildingConsumption extends Component {
		
	constructor(props) {
    super(props);

		this.state = {
			electricity: 'electricityMonthly',
			naturalGas: 'naturalGasMonthly',
			districtHeating: 'districtHeatingMonthly',
			districtCooling: 'districtCoolingMonthly',
		};		
 }
	
	toggle = (e, tab) => {
			this.setState({ 
				[e.target.name]: tab,
			})
	}
	
	handleBlur = (e, name) => {
		
		const data = this.props.energyArray;
		const filteredData = _.filter(data, c => c.textbox !== e.target.name);
		const newData = [{type: name, textbox: e.target.name, value: e.target.value}];
		const updatedData = update(filteredData, {$push: newData});
		this.setState({
			[e.target.name]: e.target.value,
		});

		this.props.onEnergyChange( updatedData );
	}	
  	
	handleChange = (e) => {
		this.setState({
				[e.target.name]: e.target.value,
		});
	}	
	
	handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			e.target.blur();
			e.preventDefault();
		}
	}
	
	renderSwitch(param) {
		switch(param) {
			case 'electricity':
				return 'Electricity (kWh)';
			case 'naturalGas':
				return 'Natural Gas (m³)';
			case 'districtHeating':
				return 'District Heating Steam (lbs)';
			case 'districtCooling':
				return 'Deep Lake Water Cooling (ton-hours)';
			default:
			  return '';
		}
	}

  render() {
		
    return (
			this.props.energySource.map(i => 

			<Col md={12} lg={6} className={i} key={i}>
				<div>{this.renderSwitch(i)}</div>			
				<ButtonGroup>			
					<Button color='light' 
						name={i}
						className={classnames({ active: this.state[i] === i + 'Monthly'})}
						onClick={(e) => { this.toggle(e, i + 'Monthly'); }}
					>
						Monthly
					</Button>
					<Button color='light' 
						name={i}
						className={classnames({ active: this.state[i] === i + 'Annual'})}
						onClick={(e) => { this.toggle(e, i + 'Annual'); }}
					>
						Annual
					</Button>	
				</ButtonGroup>
				<TabContent activeTab={this.state[i]}>
					<TabPane tabId={i + 'Monthly'}>
						<FormGroup row>
							<Label sm={7}>1st month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month1'} 
									value={this.state[i + 'Month1']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month1'), _.property('value'))[0]}
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>2nd month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month2'} 
									value={this.state[i + 'Month2']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month2'), _.property('value'))[0]}
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>3rd month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month3'} 
									value={this.state[i + 'Month3']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month3'), _.property('value'))[0]}
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>4th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month4'} 
									value={this.state[i + 'Month4']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month4'), _.property('value'))[0]}
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>5th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month5'} 
									value={this.state[i + 'Month5']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month5'), _.property('value'))[0]}
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>6th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month6'} 
									value={this.state[i + 'Month6']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month6'), _.property('value'))[0]}
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>7th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month7'} 
									value={this.state[i + 'Month7']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month7'), _.property('value'))[0]}									
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>8th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month8'} 
									value={this.state[i + 'Month8']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month8'), _.property('value'))[0]}									
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>9th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month9'} 
									value={this.state[i + 'Month9']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month9'), _.property('value'))[0]}									
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>10th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month10'} 
									value={this.state[i + 'Month10']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month10'), _.property('value'))[0]}
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>11th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month11'} 
									value={this.state[i + 'Month11']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month11'), _.property('value'))[0]}									
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
							<Label sm={7}>12th month</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Month12'} 
									value={this.state[i + 'Month12']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Month12'), _.property('value'))[0]}									
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
						</FormGroup>
					</TabPane>	
					<TabPane tabId={i + 'Annual'}>
						<FormGroup row>
							<Label sm={7}>12 months</Label>
							<Col sm={5}>
								<Input type='number' placeholder='0' className='text-right' name={i + 'Annual'} 
									value={this.state[i + 'Annual']} 
									defaultValue={_.map(this.props.energyArray.filter(c => c.textbox === i + 'Annual'), _.property('value'))[0]}									
									onChange={(e) => {this.handleChange(e)}}
									onBlur={(e) => this.handleBlur(e, i)}
									onKeyPress={this.handleKeyPress}
								/>
							</Col>
						</FormGroup>
					</TabPane>					
				</TabContent>
			</Col>
			)
		)	
	}
}
		
export default BenchmarkBuildingConsumption;


// WEBPACK FOOTER //
// ./src/BenchmarkBuildingConsumption.js